import React from 'react';
import { Chip } from '@mui/material';
import { alpha } from '@mui/material/styles';

const STATUS_COLOR = {
  scheduled: 'info',
  completed: 'success',
  cancelled: 'error',
  canceled: 'error',
  pending: 'warning',
  new: 'info',
  handled: 'success',
  published: 'success',
  draft: 'warning',
  active: 'success',
  emergency: 'error',
  urgent: 'error',
  high: 'error',
  medium: 'warning',
  low: 'success',
};

/**
 * Soft-tinted semantic status chip. Maps common status strings to colors;
 * accepts a `color` prop to override.
 */
const StatusChip = ({ status, color, size = 'small', sx, ...rest }) => {
  const key = String(status || '').toLowerCase();
  const semantic = color || STATUS_COLOR[key] || 'default';
  const label = rest.label || (status ? String(status).charAt(0).toUpperCase() + String(status).slice(1) : '—');

  return (
    <Chip
      size={size}
      label={label}
      sx={{
        fontWeight: 700,
        ...(semantic !== 'default'
          ? {
              color: (theme) =>
                theme.palette.mode === 'light'
                  ? theme.palette[semantic].dark
                  : theme.palette[semantic].light,
              bgcolor: (theme) => alpha(theme.palette[semantic].main, 0.14),
            }
          : {
              color: 'text.secondary',
              bgcolor: (theme) => alpha(theme.palette.text.secondary, 0.1),
            }),
        ...sx,
      }}
      {...rest}
    />
  );
};

export default StatusChip;
